<div class="d-flex align-items-stretch h-100 multi-chat">
  <app-multi-chat-navigation
    (moreTicketsLoaded)="onShowMoreTickets()"
    (newTaskCreated)="createNewTask()"
    (ticketChosen)="onChooseTicket($event)"
    *ngIf="tickets.length"
    [ngClass]="{'has-ticket': chosenTicket}"
    [showMore]="showMoreBtnShow"
    [ticketsCount]="tickets.length"
    [tickets]="tickets"
    class="multi-chat-navigation flex-grow-1"
  ></app-multi-chat-navigation>
  <app-multi-chat-display
    (newTaskCreated)="createNewTask()"
    (questionAsked)="currentTicketEvent.onAskQuestion$.next($event)"
    (rateSet)="currentTicketEvent.onSetRate$.next($event)"
    (unsolvedApproved)="currentTicketEvent.onTicketUnsolvedApprove$.next($event)"
    *ngIf="tickets.length && chosenTicket"
    [chosenTicket]="chosenTicket"
    [isExpertTyping]="currentTicketEventFlag.isExpertTyping"
    [isTicketHasNewMessage]="currentTicketEventFlag.ticketHasNewMessage"
    [onMessagesRead$]="currentTicketEvent.onMessagesRead$"
    class="multi-chat-display flex-grow-1"
  ></app-multi-chat-display>
  <app-multi-chat-clear
    (newTaskCreated)="createNewTask()"
    *ngIf="!tickets.length"
    class="flex-grow-1"
  ></app-multi-chat-clear>
</div>
